import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import './SearchBar.css';

const SearchBar = ({ onSearch }) => {
    const [term, setTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false); // Add loading state

    const handleTerm = (event) => {
        setTerm(event.target.value);
    }

    const handleSearch = () => {
        setIsLoading(true);
    
        try {
            onSearch(term).then(() => {
                setIsLoading(false);
            });
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    };
    

    return (
        <div className="SearchBar">
            <input placeholder="Enter A Song, Album, or Artist" onChange={handleTerm} />
            {!isLoading && (
                <button className="SearchButton" onClick={handleSearch}>SEARCH</button>
            )}
            {isLoading && <FontAwesomeIcon icon={faSpinner} spin className="LoadingIcon" />}
        </div>
    );
}

export default SearchBar;
